/**
 * DEV-1990 (эпик DEV-1980). Третья вкладка конструктора воронки — справочник
 * типов задач.
 *
 * Отдельным модулем, как documentTypes: строки нужны вкладке, двум модалкам и списку,
 * а общий ru.ts правят несколько эпиков сразу.
 *
 * Названия самих типов сюда НЕ кладём: они приходят с бэка на локали запроса —
 * справочник редактируемый, и зашитый в клиент список разошёлся бы с ним при
 * первом же новом типе.
 */

const ru = {
  title: 'Типы задач',
  subtitle: 'Чем задача является по существу: звонок, касание, встреча. Тип необязателен.',
  add: 'Новый тип',
  createTitle: 'Новый тип задачи',
  editTitle: 'Тип задачи',
  name: 'Название',
  nameHint: 'Как тип называется в списке и на чипе задачи',
  nameRequired: 'Укажите название',
  icon: 'Иконка',
  iconNone: 'Без иконки',
  active: 'Активен',
  inactiveHint: 'Выключенный тип не предлагается в формах, но остаётся на заведённых задачах.',
  system: 'Системный',
  columnCount: 'Задач',
  empty: 'Типов задач пока нет',
  emptyHint: 'Заведите первый тип — им можно будет помечать задачи и фильтровать по нему.',
  saved: 'Тип задачи сохранён',
  deleted: 'Тип задачи удалён',
  delete: {
    title: 'Удалить тип «{name}»?',
    note: 'Тип снимется с {count} задач — сами задачи останутся.',
    noteUnused: 'Этим типом не помечена ни одна задача.',
    hint: 'Вернуть тип задачам после удаления можно будет только вручную.',
    confirm: 'Удалить',
    confirmForce: 'Всё равно удалить',
  },
}

const en = {
  title: 'Task types',
  subtitle: 'What a task is in essence: a call, a touch, a meeting. The type is optional.',
  add: 'New type',
  createTitle: 'New task type',
  editTitle: 'Task type',
  name: 'Name',
  nameHint: 'How the type is named in the list and on a task chip',
  nameRequired: 'Enter a name',
  icon: 'Icon',
  iconNone: 'No icon',
  active: 'Active',
  inactiveHint: 'An inactive type is not offered in forms but stays on existing tasks.',
  system: 'System',
  columnCount: 'Tasks',
  empty: 'No task types yet',
  emptyHint: 'Add the first type — tasks can then be labelled and filtered by it.',
  saved: 'Task type saved',
  deleted: 'Task type deleted',
  delete: {
    title: 'Delete the type “{name}”?',
    note: 'The type will be removed from {count} tasks — the tasks themselves stay.',
    noteUnused: 'No task is labelled with this type.',
    hint: 'After deletion the type can only be put back on tasks by hand.',
    confirm: 'Delete',
    confirmForce: 'Delete anyway',
  },
}

const vn = {
  title: 'Loại công việc',
  subtitle: 'Bản chất của công việc: cuộc gọi, liên hệ, cuộc họp. Loại là tuỳ chọn.',
  add: 'Loại mới',
  createTitle: 'Loại công việc mới',
  editTitle: 'Loại công việc',
  name: 'Tên',
  nameHint: 'Tên hiển thị trong danh sách và trên chip công việc',
  nameRequired: 'Hãy nhập tên',
  icon: 'Biểu tượng',
  iconNone: 'Không có biểu tượng',
  active: 'Đang bật',
  inactiveHint: 'Loại đã tắt không được đề xuất trong biểu mẫu nhưng vẫn giữ trên công việc cũ.',
  system: 'Hệ thống',
  columnCount: 'Công việc',
  empty: 'Chưa có loại công việc',
  emptyHint: 'Hãy tạo loại đầu tiên — sau đó có thể gắn nhãn và lọc công việc theo loại.',
  saved: 'Đã lưu loại công việc',
  deleted: 'Đã xoá loại công việc',
  delete: {
    title: 'Xoá loại «{name}»?',
    note: 'Loại sẽ được gỡ khỏi {count} công việc — bản thân công việc vẫn giữ nguyên.',
    noteUnused: 'Chưa có công việc nào gắn loại này.',
    hint: 'Sau khi xoá, chỉ có thể gắn lại loại cho công việc bằng tay.',
    confirm: 'Xoá',
    confirmForce: 'Vẫn xoá',
  },
}

export const taskTypesMessages = {
  ru: { pipeline: { taskTypes: ru, constructor: { tabTaskTypes: 'Типы задач' } } },
  en: { pipeline: { taskTypes: en, constructor: { tabTaskTypes: 'Task types' } } },
  vn: { pipeline: { taskTypes: vn, constructor: { tabTaskTypes: 'Loại công việc' } } },
}
